import { Print } from "@mui/icons-material";
import { Tooltip, Typography } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import CircularLoading from "../../../../commons/loadingData/circularLoading";
import { StyledAccidentPrePrintedFormsCards } from "../../../../styled/accident";

const AccidentFormsCards = ({ data, loading, generatePrePrintedHTML }) => {
  const esPrestador = useSelector((state) => state.auth.roles?.PRESTADOR);

  return (
    <StyledAccidentPrePrintedFormsCards.Container>
      {loading ? (
        <CircularLoading />
      ) : data.length ? (
        data.map((form) => (
          <StyledAccidentPrePrintedFormsCards.Card
            key={form.idPlantillaPreImpresion}>
            <Typography variant="body2">{form.nombre}</Typography>
            {esPrestador && (
              <Tooltip
                title="Emitir formulario"
                onClick={() => generatePrePrintedHTML(form)}>
                <StyledAccidentPrePrintedFormsCards.Button>
                  <Print />
                </StyledAccidentPrePrintedFormsCards.Button>
              </Tooltip>
            )}
          </StyledAccidentPrePrintedFormsCards.Card>
        ))
      ) : (
        <StyledAccidentPrePrintedFormsCards.EmptyState variant="body2">
          No hay formularios disponibles
        </StyledAccidentPrePrintedFormsCards.EmptyState>
      )}
    </StyledAccidentPrePrintedFormsCards.Container>
  );
};

export default AccidentFormsCards;
